import React from 'react';
import ReactDOM from 'react-dom';
import RankingLeaderboard from '../components/rankingLeaderboard/RankingLeaderboard';
import { initializeI18n } from '../localization/i18n';

// Expose render function globally
window.renderRankingLeaderboard = (elementId, props) => {
    const element = document.getElementById(elementId);
    if (element) {

        initializeI18n()
            .then((i18nInstance) => {
                ReactDOM.render(<RankingLeaderboard props={props} />, element);
            })
            .catch(error => {
                //console.error("Failed to initialize i18n before rendering RealTimeLectureDetail:", error);
            });

    } else {
        //console.error(`Element with ID ${elementId} not found.`);
    }
};